import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { Userpilot } from 'userpilot';
import '@/index.css';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';

const sentryEnabled = !import.meta.env.VITE_DISABLE_SENTRY;

Sentry.init({
  dsn: sentryEnabled ? import.meta.env.VITE_SENTRY_DSN : undefined,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^https:\/\/staging-client\.energie\.hellio\.dev/,
    /^https:\/\/dev-client\.energie\.hellio\.dev/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (import.meta.env.VITE_USERPILOT_TOKEN) {
  Userpilot.initialize(import.meta.env.VITE_USERPILOT_TOKEN);
}

const rootElement = document.getElementById('root')!;

createRoot(rootElement).render(
  <React.StrictMode>
     <HelmetProvider>
        <App />
     </HelmetProvider>
  </React.StrictMode>,
);
